import React, { useState } from 'react';
import { Grid, Card, CardContent, Typography, Box, Fab, Menu, MenuItem, AppBar, Toolbar, IconButton, Dialog, DialogActions, DialogContent, DialogTitle, Button, Divider, TextField } from '@mui/material';
import logo from './assets/logo.png'; // Import the logo image
import TuneIcon from '@mui/icons-material/Tune'; // Filter icon for FAB
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import EditNoteIcon from '@mui/icons-material/EditNote';
import RateReviewIcon from '@mui/icons-material/RateReview';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import TimerIcon from '@mui/icons-material/Timer';

// Sample order data
const orders = [
  {
    id: 1, orderNumber: 'ORD001', customer: 'John Doe', status: 'Pending', date: '2025-01-08T19:31:01', total: 120, totalItems: 2, items: [
      { name: 'Burger', quantity: 1, ingredientsRequest: 'No Pickles' },
      { name: 'Fries', quantity: 2, ingredientsRequest: '' }
    ]
  },
  {
    id: 2, orderNumber: 'ORD002', customer: 'Jane Smith', status: 'Completed', date: '2025-01-08T19:20:00', total: 75, totalItems: 2, items: [
      { name: 'Salad', quantity: 1, ingredientsRequest: '' },
      { name: 'Chicken Sandwich', quantity: 1, ingredientsRequest: 'Add Bacon' },

    ]
  },
  {
    id: 3, orderNumber: 'ORD003', customer: 'Mark Johnson', status: 'Processing', date: '2025-01-06T11:15:00', total: 150, totalItems: 3, items: [
      { name: 'Pasta', quantity: 1, ingredientsRequest: '' },
      { name: 'Large Coke', quantity: 1, ingredientsRequest: '' },
      { name: 'Garlic Bread', quantity: 1, ingredientsRequest: 'Extra Butter' }
    ]
  },
  {
    id: 3, orderNumber: 'ORD003', customer: 'Mark Johnson', status: 'Processing', date: '2025-01-06T11:15:00', total: 150, totalItems: 3, items: [
      { name: 'Pasta', quantity: 1, ingredientsRequest: '' },
      { name: 'Large Coke', quantity: 1, ingredientsRequest: '' },
      { name: 'Garlic Bread', quantity: 1, ingredientsRequest: 'Extra Butter' }
    ]
  },
  {
    id: 3, orderNumber: 'ORD003', customer: 'Mark Johnson', status: 'Processing', date: '2025-01-06T11:15:00', total: 150, totalItems: 3, items: [
      { name: 'Pasta', quantity: 1, ingredientsRequest: '' },
      { name: 'Large Coke', quantity: 1, ingredientsRequest: '' },
      { name: 'Garlic Bread', quantity: 1, ingredientsRequest: 'Extra Butter' }
    ]
  },
  {
    id: 3, orderNumber: 'ORD003', customer: 'Mark Johnson', status: 'Processing', date: '2025-01-06T11:15:00', total: 150, totalItems: 3, items: [
      { name: 'Pasta', quantity: 1, ingredientsRequest: '' },
      { name: 'Large Coke', quantity: 1, ingredientsRequest: '' },
      { name: 'Garlic Bread', quantity: 1, ingredientsRequest: 'Extra Butter' }
    ]
  },
  {
    id: 3, orderNumber: 'ORD003', customer: 'Mark Johnson', status: 'Processing', date: '2025-01-06T11:15:00', total: 150, totalItems: 3, items: [
      { name: 'Pasta', quantity: 1, ingredientsRequest: '' },
      { name: 'Large Coke', quantity: 1, ingredientsRequest: '' },
      { name: 'Garlic Bread', quantity: 1, ingredientsRequest: 'Extra Butter' }
    ]
  },  {
    id: 3, orderNumber: 'ORD003', customer: 'Mark Johnson', status: 'Processing', date: '2025-01-06T11:15:00', total: 150, totalItems: 3, items: [
      { name: 'Pasta', quantity: 1, ingredientsRequest: '' },
      { name: 'Large Coke', quantity: 1, ingredientsRequest: '' },
      { name: 'Garlic Bread', quantity: 1, ingredientsRequest: 'Extra Butter' }
    ]
  },
  // Add more orders here
];

const Orders = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [orderToDelete, setOrderToDelete] = useState(null);
  


  // State to track the selected order for expansion
  // State to handle menu opening and closing
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);


  // Handle FAB button click to open menu
  const handleFabClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
  };


  // Sort orders by date (most recent first)
  const sortedOrders = orders.sort((a, b) => new Date(b.date) - new Date(a.date));

  // Helper function to calculate time elapsed
 // Helper function to calculate time elapsed
const getTimeElapsed = (orderDate) => {
  const orderTime = new Date(orderDate);
  const currentTime = new Date();
  const elapsedMinutes = Math.floor((currentTime - orderTime) / 60000); // Convert milliseconds to minutes

  let elapsedText = '';
  let elapsedColor = '';

  const elapsedHours = Math.floor(elapsedMinutes / 60);
  const remainingMinutes = elapsedMinutes % 60;

  // Handle time display (hours and minutes)
  if (elapsedHours > 0) {
    elapsedText = `${elapsedHours} hour(s) and ${remainingMinutes} minute(s) ago`;
  } else {
    elapsedText = `${elapsedMinutes} minute(s) ago`;
  }

  // Set color based on elapsed time
  if (elapsedMinutes < 5) {
    elapsedColor = 'green';
  } else if (elapsedMinutes >= 5 && elapsedMinutes <= 15) {
    elapsedColor = 'orange';
  } else {
    elapsedColor = 'red';
  }

  return { elapsedText, elapsedColor };
};



const handleOrderClick = (order) => {
  handleOpenDialog(order); // Open the dialog when an order is clicked
};

  // Handle closing the expanded order view
  const handleCloseOrder = () => {
    setSelectedOrder(null); // Reset selected order to collapse the expanded view
  };


  const handleOpenDialog = (order) => {
    setOrderToDelete(order);
    setOpenDialog(true);
  };
  
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setOrderToDelete(null);
  };
  
  const handleConfirmDelete = () => {
    // Logic to delete the order
    console.log("Order deleted:", orderToDelete);
    setOpenDialog(false);
    setOrderToDelete(null);
  };
  
  


  return (
    <div style={{ padding: '0px', backgroundColor: '#2e2e2e', minHeight: '100vh' }}>
      <AppBar position="static" style={{ backgroundColor: '#336699' }}>
        <Toolbar>
          <Box display="flex" alignItems="center" justifyContent="flex-start" style={{ flexGrow: 1 }}>
            <img
              src={logo} // Path to your Logo.png image
              alt="Logo"
              style={{
                height: '50px', // Adjust the size of the logo
                width: 'auto',
              }}
            />
          </Box>
          <IconButton edge="end" color="inherit" aria-label="book" href="/orders" style={{marginLeft:'3.5%'}}>
            <TimerIcon/>
          </IconButton>
          <IconButton edge="end" color="inherit" aria-label="book" href="/menu" style={{marginLeft:'3.5%'}}>
            <BorderColorIcon />
          </IconButton>
          <IconButton edge="end" color="inherit" aria-label="book" href="/history" style={{marginLeft:'3.5%'}}>
            <AutoStoriesIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Dialog open={openDialog} onClose={handleCloseDialog}>
  <DialogTitle>Confirm Delete</DialogTitle>
  <DialogContent>
    <Typography>Are you sure you want to delete order {orderToDelete?.orderNumber}?</Typography>
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCloseDialog} color="primary">
      Cancel
    </Button>
    <Button onClick={handleConfirmDelete} color="secondary">
      Delete
    </Button>
  </DialogActions>
</Dialog>

      <div style={{ padding: '20px' }}>
        {/* Grid layout for orders */}
        <Grid container spacing={3}>
          {sortedOrders.map((order) => {
            const { elapsedText, elapsedColor } = getTimeElapsed(order.date); // Calculate time elapsed and color
            return (
              <Grid item xs={12} sm={6} md={4} key={order.id}>
                {/* Order Card */}
                <Card
                  sx={{
                    borderRadius: '16px',
                    backgroundColor: '#444',
                    minHeight: '500px',
                    boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.2)',
                    border: `4px solid ${elapsedColor}`, // Add border with color based on elapsed time
                    transition: 'transform 0.3s ease',
                    '&:hover': {
                      transform: 'scale(1.05)',
                    },
                  }}
                  onClick={() => handleOrderClick(order)}
                >
                  <CardContent>
                    <Box display="flex" flexDirection="column">
                      {/* Order Number */}
                      <Typography variant="h6" gutterBottom style={{ fontSize: '25px', color: '#fff' }}>
                        {order.orderNumber}
                      </Typography>
                      {/* Time Placed and Time Elapsed */}
                      <Typography variant="body2" style={{ fontSize: '23px', color: '#e0e0e0' }} gutterBottom>
                        Time Placed: {new Date(order.date).toLocaleString(undefined, { hour: '2-digit', minute: '2-digit', year: 'numeric', month: '2-digit', day: '2-digit' })}
                      </Typography>

                      <Typography variant="body2" style={{ fontSize: '22px', color: elapsedColor }} gutterBottom>
                        Time Elapsed: {elapsedText}
                      </Typography>
                      {/* Customer and Other Details */}
                      <Typography variant="body2" style={{ fontSize: '22px', color: '#e0e0e0' }} gutterBottom>
                        Customer: {order.customer}
                      </Typography>
                      <Typography variant="body2" style={{ fontSize: '22px', color: '#e0e0e0' }} gutterBottom>
                        Total: ${order.total}
                      </Typography>
                      <Typography variant="body2" style={{ fontSize: '22px', color: '#e0e0e0' }}>
                        Total Items: {order.totalItems}
                      </Typography>
                    </Box>

                    {/* Divider between order summary and items */}
                    <Divider style={{ margin: '20px 0', backgroundColor: '#ccc' }} />

                    {/* Grid for Order Items (Items in rows) */}
                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '30px' }}>
                      {order.items.map((item, index) => (
                        <Box key={index} display="flex" flexDirection="column" marginBottom="10px" style={{ color: '#fff' }}>
                          <Typography style={{ fontSize: '25px', fontWeight: 'bold', }} variant="body2">
                            {index + 1} of {order.totalItems} - {item.name}
                          </Typography>

                          {item.ingredientsRequest && (
                            <Typography variant="body2" style={{ fontSize: '22px', color: '#e0e0e0' }}>
                              Ingredients Request: <br></br>{item.ingredientsRequest}
                            </Typography>
                          )}
                        </Box>
                      ))}
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
        {/* Floating Action Button for Filtering */}
        <Fab
          aria-label="filter"
          style={{
            color: '#336699',
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 10,
          }}
          onClick={handleFabClick}
        >
          <TuneIcon />
        </Fab>
        {/* Dialog for displaying expanded order */}
        {selectedOrder && (
          <Dialog open={true} onClose={handleCloseOrder} maxWidth="md" fullWidth>
            <DialogTitle>Order Details</DialogTitle>
            <DialogContent>
              <Box display="flex" flexDirection="column" alignItems="center">
                <Typography variant="h5" style={{ marginBottom: '20px' }}>
                  {selectedOrder.orderNumber}
                </Typography>
                <Typography variant="h6" style={{ color: '#e0e0e0' }}>
                  Customer: {selectedOrder.customer}
                </Typography>
                <Typography variant="h6" style={{ color: '#e0e0e0' }}>
                  Total: ${selectedOrder.total}
                </Typography>
                {/* Render items for expanded view */}
                {selectedOrder.items.map((item, index) => (
                  <Box key={index} display="flex" flexDirection="column" style={{ color: '#fff' }}>
                    <Typography variant="body2">
                      {index + 1} of {selectedOrder.totalItems} - {item.name}
                    </Typography>
                    {item.ingredientsRequest && (
                      <Typography variant="body2" style={{ color: '#e0e0e0' }}>
                        Ingredients Request: {item.ingredientsRequest}
                      </Typography>
                    )}
                  </Box>
                ))}
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseOrder} color="primary">Close</Button>
            </DialogActions>
          </Dialog>
        )}
      </div>
    </div>
  );
};

export default Orders;
